"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */

var noop = function noop() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return undefined;
};

noop.noop = true;
exports.default = noop;